module.exports = __webpack_public_path__ + "static/media/krx-derivatives-seeds-tablet.cecfde0d.jpg";